// import { createAsyncThunk } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/use-http";

const postVirtour = createAsyncThunk(
  "history/getVacancies",
  async ({ data }) => {
    const { request } = useHttp();
    return await request({
      url: "/press_center/virtual_reception/",
      method: "POST",
      data,
    });
  }
);

export { postVirtour };
